import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { Router } from '@angular/router';

export interface questionsList {
  category: string,
  question: string,
  answers: [],
  correctAnswer: string,
  page: string,
  Progress: string,
  description: [],
  points: [];
  descriptionPoints: []
}

@Injectable({ providedIn: 'root' })
export class Service {
  key;




  // the list of questions and their answers
  questions = [
    {
      id: 0,
      question: 'Is your will more than 5 years old, or do you still need to prepare a will?',
      answers: ['Yes', 'No', 'Not Sure', 'N/A'],
      page: '1/12',
      Progress: 8,
      header: 'Prepare or update your will',
      points: [
        'An up-to-date will is the most important component of an estate plan',
        'A will should be reviewed at least every five years or whenever significant life events occur',
        'You should appoint representatives to look after your affairs if you ever become mentally incapable'
      ],
      description: [
        'An up-to-date will is usually the most important component of an effective estate plan. Once prepared, a will should be reviewed at least every five years to ensure that it reflects your current personal and financial circumstances and objectives and that it addresses the latest changes to estate, tax, insurance and family law.\n\n',
        'In addition, your will needs to be updated whenever significant life events occur such as marriage, the birth of a child, or the death of a spouse or child.\n\n',
        'When meeting with an estate lawyer, you should also prepare or update the documents used in your province of residence to appoint representatives to look after your financial, legal, personal and health care matter, should you ever become mentally incapable.\n'
      ],
      descriptionPoints: []
    },
    {
      id: 1,
      question: 'Are you concerned about the tax liability which will arise at death?',
      answers: ['Yes', 'No', 'Not Sure', 'N/A'],
      page: '2/12',
      Progress: 16,
      header: 'Prepare an estimate of your tax liability at death and minimize taxes where possible ',
      points: [
        'There are taxes associated with a "deemed disposition" of assets at death',
        'Registered plans may be deemed to have been cashed out, and the proceeds may be included in your income as at the date of death',
        'There are several ways to reduce or eliminate taxes after death'
      ],
      description: [
        'Canada has no estate or inheritance taxes, but there are taxes associated with "deemed disposition" of assets at death. At the date of death, you are deemed to have sold all of your capital assets (except those passed to a spouse or common-law partner).\n\n',
        'In addition, any registered plan you hold will be deemed to have been cashed out, and the proceeds must be included in your income as at the date of death. The exceptions are plans passed to a spouse or common-law partner or, in certain circumstances, a dependent child or grandchild.\n\n',
        'There are several ways in which income taxes can be reduced or eliminated in the terminal return:',
      ],
      descriptionPoints: [
        'Allocate assets to a spouse or common-law partner or to a spousal trust (a trust set up to hold assets for the benefit of your spouse or common-law partner). Assets can be transferred on a tax-deferred basis, thereby reducing taxes in your estate.',
        'Designate beneficiaries to inherit your registered plans',
        'Set up life insurance or a Tax-Free Savings Account to provide tax-free monies to offset taxes',
        'Set up a donation to charity. The donation receipt can be used to provide a donation tax credit for your terminal return. In addition, if your executor donates securities ‘in kind’ that have unrealized capital gains, the gain will be eliminated, which will reduce tax on your estate',
      ]
    },
    {
      id: 2,
      question: 'Are you concerned about probate fees reducing your estate value?',
      answers: ['Yes', 'No', 'Not Sure', 'N/A'],
      page: '3/12',
      Progress: 24,
      header: 'Consider strategies to reduce or eliminate probate costs',
      points: [
        'There are several strategies that can help reduce probate costs',
        'You should review the beneficiary designations on any registered plan assets',
        'The probate costs saved should be greater than the costs of any strategy considered'
      ],
      description: [
        'Any strategy used to reduce or eliminate probate costs should not have a higher cost than the amount saved. If you expect your estate to incur substantial probate costs, consider the following strategies to reduce them:'
      ],
      descriptionPoints: [
        'Use beneficiary designations for registered plans and life insurance products. The beneficiary will receive the asset directly upon your death, rather than having that asset be part of your estate and subject to probate costs',
        'Hold assets jointly, that is, joint tenancy with right of survivorship. If your intention when the joint tenancy is created is properly documented, this registration will generally allow the asset to pass directly to the surviving joint tenant when you die',
        'Gifting prior to death. Other strategies include giving assets away while alive or transferring them to an inter vivos trust. Gift or transfer assets you no longer need, but remember that there will generally be income tax implications depending on the person to whom you make the gift',
        'Convert debt. A last strategy involves converting unsecured debt to a mortgage against real estate. The probate calculation will only include the value of the real estate, net of the mortgage',
      ]

    },
    {
      id: 3,
      question: 'Do you own life insurance or other insurance products, or an RRSP or RRIF?',
      answers: ['Yes', 'No', 'Not Sure', 'N/A'],
      page: '4/12',
      Progress: 32,
      header: 'Consider designating beneficiaries to minimize tax and/or to direct a specific gift',
      points: [
        'The way in which you designate beneficiaries on life insurance and registered plan assets can have a significant impact on your estate distribution'
      ],
      description: [
        'Upon death, assets you own generally become part of your estate for distribution according to your will. That process can be useful if you want assets held in a trust for one or more beneficiaries. However, estate assets may be subject to probate fees, dependants\' relief laws, and the claims of creditors.\n\n',
        'To minimize those complications, you can designate one or more beneficiaries on your registered plans or insurance policies, and the plan or insurance assets will pass directly to your specified beneficiaries – which can include charities upon your death.\n\n',
        'While a similar beneficiary designation can be made in your will to allow the plan or insurance assets to bypass your estate, designating the beneficiary on the application documentation itself (or on a specific form) may be a better option.'
      ],
      descriptionPoints: []

    },
    {
      id: 4,
      question: 'Do you have concerns that your beneficiaries may receive too much money upon your death?',
      answers: ['Yes', 'No', 'Not Sure', 'N/A'],
      page: '5/12',
      Progress: 40,
      header: 'Consider establishing a testamentary trust',
      points: [
        'A Testamentary Trust may be a useful consideration if you have minor beneficiaries',
        'They can also provide privacy or be used if a beneficiary is less capable of managing investment assets '
      ],
      description: [
        'Testamentary trusts are set up to hold assets for the benefit of one or more beneficiaries, as opposed to a direct inheritance for those beneficiaries.',
        'Testamentary trusts are separate taxpayers and provide protection for your estate assets.\n\n',
        'You may wish to consider a trust in the following circumstances:'
      ],
      descriptionPoints: [
        'Minor beneficiaries who will be unable to manage financial assets ',
        'Beneficiaries who you feel may not handle money responsibly',
        'Where privacy is important (Trust agreements are not public, a probated will may be)',
        'A Spousal Trust provides your spouse with income from the trust while he or she is alive, and defers capital gains taxes',
        'A Trust set up for a beneficiary eligible for the disability tax credit may have lower (graduated) rates of taxation'
      ]
    },
    {
      id: 5,
      question: 'Are you planning to make a charitable donation upon your death?',
      answers: ['Yes', 'No', 'Not Sure', 'N/A'],
      page: '6/12',
      Progress: 48,
      header: 'Plan ahead to take advantage of tax minimization strategies',
      points: [
        'Charitable donations can help reduce the tax liability of your estate',
        'Capital gains tax is not assessed on donations of publicly traded securities',
        'A charitable giving fund can help you leave a long lasting legacy'
      ],
      description: [
        'When you die, you are deemed to have sold all capital property, including publicly traded securities and mutual funds at fair market value (there is an exception to this tax rule for capital property which is left to a surviving spouse or common-law partner). If capital assets have appreciated in value since they were acquired, a tax liability may result. This tax liability can be reduced or eliminated through donations made at death to Canadian registered charities, either through a will or through a beneficiary designation.\n\n',
        'In the year of death, charitable donations, can be up to a maximum of 100% of net income. If the charitable donations are not totally exhausted by that year\'s income, they can be used up to a maximum of 100% of net income in the year preceding death to create an income tax credit which can be applied to reduce income tax payable. The resulting income tax credit will reduce, and perhaps even eliminate your income tax liability for the year of death and for the year preceding death.\n\n',
        'An additional income tax benefit can be obtained if you own publicly traded securities or mutual funds which have appreciated in value. If you direct your executor in your will to donate some or all of those securities or funds ‘in kind’ to one or more Canadian registered charities, any capital gains tax liability which would otherwise arise from those securities or funds will be eliminated.\n\n',
        'Your will must clearly state the correct legal name of each Canadian registered charity which is to receive a donation, as well as the amount of the donation (or a formula for calculating that amount, such as "10% of the residue of my estate"). If you leave the choice of the charity, or the choice of the amount of the donation, to your executor, the Canada Revenue Agency may consider the donation as having been made by your estate (rather than by you), and your estate will receive the income tax credit. Should this occur, the income tax credit will be unavailable to provide the tax relief you will likely need in your year of death tax return.\n\n',
        'To enhance the value to recipients of your charitable donations, you may want to consider creating a personal Charitable Giving Fund prior to death so that the donations made at death can be used to fund grants to your favourite Canadian registered charities on an annual, ongoing basis after your death. You could give your Charitable Giving Fund its own name, and either provide standing directions with respect to recipients and grant amounts to be made from the fund or appoint someone to make those decisions on your behalf. One advantage of using a charitable giving fund is that each charity you wish to benefit will receive ongoing annual grants rather than one large lump sum upon your death.\n\n',
        'The annual grants may better match the funding needs of the charities and build a legacy for you and your family that will live on for many years.',
      ],
      descriptionPoints: []
    },
    {
      id: 6,
      question: 'Do you own a business?',
      answers: ['Yes', 'No', 'Not Sure', 'N/A'],
      page: '7/12',
      Progress: 56,
      header: 'Consider an estate freeze to minimize your tax exposure',
      points: [
        'An estate freeze can help you control and defer the taxation of capital gains on corporate assets',
        'If applicable, the lifetime capital gains exemption can help reduce the taxes associated with transferring a business to the next generation'
      ],
      description: [
        'You can transfer an interest in your business to someone else without incurring immediate tax consequences.\n\n',
        'An estate freeze allows you to accomplish several things: continued control over the business and its value to your desired level, freeze and defer the tax liability accrued to-date, shift some or all of the future growth of the business to others (family, key employees, third parties), receive financial benefit during your lifetime through dividends, salary, or redemption of shares.\n\n',
        'If your business is incorporated, an estate freeze usually involves a reorganization of the share structure of the company and the exchange of your existing company shares for single purpose "voting" shares and frozen "preferred" shares. If your business is run as a proprietorship or a partnership, it will need to be incorporated (utilizing voting, preferred, and "common" shares) before the estate freeze can occur. The voting shares give you continued control of the company.\n\n',
        'The preferred shares hold the value of the company at the time of the freeze and will not increase in value as the company continues to grow. The common shares allow you to pass future business growth to others, or to participate in that future growth yourself. If you wish, you can treat the preferred shares as a retirement fund, asking the company to redeem some of them from time to time and paying income tax on the value of the shares redeemed.\n\n',
        'Separation of the control of the company (through voting shares) and the value of the company (through preferred shares) allows you to give control of the company to one or more people during your lifetime or after your death through the sale or gifting of the voting shares. Any preferred shares remaining at your death can be given to the people you wish to benefit financially - perhaps your spouse, or your spouse and your children divided equally or unequally, or perhaps your children, divided equally or unequally.\n\n',
        'If your existing shares at the time of the freeze are "qualifying small business corporation shares" for the purpose of the Income Tax Act of Canada, you may wish to utilize any remaining portion of your enhanced capital gains exemption as part of the freeze. This would reduce or eliminate tax payable at the time the estate freeze is implemented.\n',
      ],
      descriptionPoints: [
        'Continued control over the business and its value to your desired level',
        'Freeze and defer the tax liability accrued to-date',
        'Shift some or all of the future growth of the business to others (family, key employees, third parties)',
        'Receive financial benefit during your lifetime through dividends, salary, or redemption of shares',
      ]
    },
    {
      id: 7,
      question: 'Have you, or are you contemplating, putting your assets in joint name?',
      answers: ['Yes', 'No', 'Not Sure', 'N/A'],
      page: '8/12',
      Progress: 64,
      header: 'Consider transferring title to assets to create a joint tenancy with your intended heirs',
      points: [
        'Creating joint tenancy of assets may or may not be a suitable option',
        'Before setting up any joint ownership you should consult an estate lawyer'
      ],
      description: [
        'In most provinces (except Quebec) individuals are allowed to hold an asset jointly with one or more other persons or corporations. There are three types of joint tenancy: "true" joint tenancy, "resulting trust" joint tenancy, or "gift of a right of survivorship" joint tenancy.\n\n',
        'If all joint tenants make equal financial contributions to acquire an asset, a true joint tenancy is created. If all joint tenants do not contribute financially, the type of joint tenancy which is created depends entirely upon the intention of the person who, or corporation which, already owns the asset or is making the financial contribution to acquire the asset. That intention should be documented - this is particularly important when all joint tenants do not contribute financially.\n\n',
        'Each type of joint tenancy carries with it different rights for the joint tenants and different tax implications. Before creating a joint tenancy, you should consult an estate lawyer to determine whether the benefits to your estate plan will outweigh the costs.',
      ],
      descriptionPoints: []

    },
    {
      id: 8,
      question: 'Do you own, or plan to own, more than one real estate property (e.g. cottage, cabin, chalet)?',
      answers: ['Yes', 'No', 'Not Sure', 'N/A'],
      page: '9/12',
      Progress: 72,
      header: 'Consider the following strategies for your real estate properties',
      points: [
        'Creating joint tenancy of assets may or may not be a suitable option',
        'Before setting up any joint ownership you should consult an estate lawyer'
      ],
      description: [
        'When you pass away, you are considered to have disposed of most of your assets at fair market value, meaning a large capital gains tax may be payable at death. While the tax on your principal residence can be sheltered with the use of the Principal Residence Exemption (PRE), other real estate properties you own could have a large tax bill if they have appreciated in value.  There are a number of strategies that can help you minimize tax payable at the time of death as well as achieve your estate planning goals.\n\n',
        'Consider the following:',
      ],
      descriptionPoints: [
        'Maximize the adjusted cost base (ACB). The higher the ACB on the second property, the lower the capital gain upon disposition. Keep receipts for renovations and additions to the property - these, added to the original purchase price, will increase your ACB',
        'Consider sharing the principal residence exemption. "Principal residence" implies that a particular property is the primary place of residence. The Income Tax Act, however, has a broader definition, and will allow a seasonal residence or mobile home to be considered the principal residence. There is a calculation, using form T2091, that will help you share the principal residence exemption between two properties for the years in which you owned both properties',
        'Claim the exemption for pre-1982 capital gains. Prior to 1982 it was possible for each spouse to obtain an exemption on a property - so one could claim the family home, and the other spouse could claim the vacation home. If you have held your properties since 1982 or earlier, don\'t forget to claim the exemption',
        '"Freeze" your tax liability by transferring or gifting ownership while you are alive to a adult child or children through gift or sale; or move the second property to an inter vivos trust Capital gains taxes are payable when ownership moves to the next generation or to the trust, but any appreciation after the gift or transfer is taxable to the new owner.',
      ]

    },
    {
      id: 9,
      question: 'Do you own, or plan to own, U.S. real estate property or significant U.S. investments? ',
      answers: ['Yes', 'No', 'Not Sure', 'N/A'],
      page: '10/12',
      Progress: 80,
      header: 'Consider avoiding being considered a U.S. resident who is required to file annual U.S. income tax returns',
      points: [
        'Creating joint tenancy of assets may or may not be a suitable option',
        'Before setting up any joint ownership you should consult an estate lawyer'
      ],
      description: [
        'Even though you are a Canadian resident and not a United States citizen, your U.S. connections may give rise to U.S. income tax and/or U.S. estate tax liabilities. Those connections may also create issues upon your death or if you become mentally incapable.\n\n',
        'If you regularly spend extended time periods in the U.S., you may be considered a U.S. resident for tax purposes. Although a U.S. "B-2" visitor\'s visa allows you to spend a maximum of 183 days each year in the U.S., if you regularly spend more than 122 days (approximately four months) each year in the U.S. you will likely, after four years, meet the U.S. "substantial presence" test. This means that you will be considered a resident of the U.S. for tax purposes and be required to file a U.S. income tax return annually in addition to your Canadian income tax return.\n\n',
        'However, as long as you do not exceed 183 days (or part days) in the U.S. in any given year, the annual tax filing requirement can be avoided by filing IRS form 8840 to show that you have a closer connection to Canada than to the U.S. Factors which show a closer connection to Canada include a home, job, personal belongings, and family located in Canada.',
      ],
      descriptionPoints: []

    },
    {
      id: 10,
      question: 'Are you open to having a meeting to discuss your estate planning objectives with your family or beneficiaries?',
      answers: ['Yes', 'No', 'Not Sure', 'N/A'],
      page: '11/12',
      Progress: 90,
      header: 'Consider hosting a family meeting with your beneficiaries',
      points: [
        'A Family Meeting can help provide significant peace of mind to your intended beneficiaries',
      ],
      description: [
        'It’s not uncommon for clients to neglect relationship issues in estate planning or to assume that these issues will take care of themselves. Yet, not addressing family dynamics often leads to emotional stress, misunderstandings and ongoing family conflict.\n',
        'A facilitated family meeting can provide an occasion to bring about greater understanding, clarity and order for your family.\n',
      ],
      descriptionPoints: []

    },
    {
      id: 11,
      question: 'Are you open to the idea of discussing your estate planning objectives with your Executor(s) to outline the key aspects of their role?',
      answers: ['Yes', 'No', 'Not Sure', 'N/A'],
      page: '12/12',
      Progress: 100,
      header: 'Appointing an Executor and outlining their responsibilities',
      points: [
        'The role of executor carries significant responsibility and is time consuming',
        'Consider carefully who you name as executor of your estate',
      ],
      description: [
        'An executor is a person named in a will to manage the distribution of the estate assets. You may find that few people are prepared for the responsibilities of this role. An executor typically applies for a certificate validating the will, takes action to protect the assets of the estate, makes distributions of property to beneficiaries and pays the debts and taxes of the estate.\n',
        'If an executor mismanages estate funds and this results in a loss for the beneficiaries, the executor can be found personally liable. A person named as an executor does have the right to refuse the position.  In this case, the will may name an alternate executor or the court may appoint another person to carry out the responsibilities.\n',
      ],
      descriptionPoints: []

    },
  ];


  // the ID of the current question displayed. Used to navigate and query a specific question.
  questionId: number;

  // The list of answers. 
  answers = [];
  userAnswers: any;

  constructor(public router: Router
  ) {



    //let questiondata: { string: questionsList[] } = JSON.parse(questionsList);
  }

  /*
    4. Store the answer. Called when the user clicks on an answer. 
    Because we are already checking if the question ID isn't greater than the total of questions, we don't need to check if the answer given by the user is the last one. 
  
    Go to answer.component.html
  */
  validate(idprem, questionPrem, answerPrem, descriptionPrem, pointsPrem, descriptionPoint, headerPrem) {
    //Find index of specific object using findIndex method.  

    // var objIndex = this.answers.find((obj => (obj.id === idprem)));
    // console.log("answer array: ", objIndex);

    //Log object to Console.
    // if (this.userAnswers != null) {
    //   //Update object's name property.
    //   //console.log("Before update: ", objIndex);
    //   //var arrayID = this.userAnswers.idprem;
    //   // console.log(this.answers[objIndex].answerPrem);
    //   this.userAnswers.answerPrem = answerPrem;
    //   console.log("After answer Update: ", this.userAnswers);
    // }
    // else {
      this.userAnswers = {
        idprem,
        questionPrem,
        answerPrem,
        pointsPrem,
        descriptionPrem,
         descriptionPoint,
        headerPrem,
  
      };
    //   console.log("After Update: ", this.userAnswers);
    // }


    this.key = JSON.stringify(this.questionId);
    sessionStorage.setItem(this.key, JSON.stringify( this.userAnswers));


  }




}

